<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div class="card-body px-lg-7 py-lg-5" style="border:2px solid #d0d0d0;border-radius:10px;">
          <div class="text-center text-muted mb-4">
            <small v-if="comercio">Hola! Comencemos el proceso de registro, por favor completá los datos de tu actividad comercial.</small>
            <small v-if="usuario">Hola! Comencemos el proceso de registro, por favor completá tus datos personales.</small>
          </div>
          <div class="text-center">
              <base-button
                type="danger"
                class="my-4 bottomButton"
                v-if="usuario"
                @click="soycomercio"
              >Soy un comercio</base-button>
              <base-button
                type="danger"
                class="my-4 bottomButton"
               v-if="comercio && IsAddUserVisible"
                @click="soyusuario"
              >Soy una persona</base-button>
            </div>
          <form role="form">
            <base-input 
              :required="model.DNI == null || model.DNI.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="DNI"
              addon-left-icon="fa fa-fw fa-id-card"
              v-model="model.DNI"
              v-if="usuario"
              :maxLength="8"
              onlyNumbers
              onlyIntegers
              type="text"
              v-on:keyup="getRenaperData"
            ></base-input>

            <!-- class="img-fluid" -->
            <b-tooltip target="tooltip-orderNumber" triggers="hover"> 
              <img src="img/nrotramite_help.jpg">
            </b-tooltip>

            <base-input 
              id="tooltip-orderNumber"
              :required="model.OrderNumber == null || model.OrderNumber.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Nro. de Trámite DNI"
              addon-left-icon="fa fa-fw fa-id-card"
              v-model="model.OrderNumber"
              v-if="usuario"
              onlyNumbers
              onlyIntegers
              type="text"
              v-on:keyup="getRenaperData"
              >
              </base-input>

            <div class="row form-group" v-if="usuario">
              <div class="col-md-12">
                <KitsCombo
                  v-model="model.GenderID"
                  v-bind:items="sexos"
                  propertyName="Name"
                  propertyID="EntityID"
                  nullText=" -- Seleccione un sexo -- "
                  :todos="true"
                  v-on:input="getRenaperData"
                ></KitsCombo>
              </div>
            </div>

            <base-input :required="model.CUIT == null || model.CUIT.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="CUIT"
              addon-left-icon="fa fa-fw fa-id-card"
              v-model="model.CUIT"
              v-if="comercio"
              onlyNumbers
              onlyIntegers
              :maxLength="11"
              type="text"
            ></base-input>

            <base-input :required="model.RazonSocial == null || model.RazonSocial.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Razón social"
              addon-left-icon="fa fa-fw fa-store"
              v-model="model.RazonSocial"
              v-if="comercio"
              :disabled = "true"
            ></base-input>

            <base-input :required="model.Nombre == null || model.Nombre.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Nombre"
              addon-left-icon="fa fa-fw fa-user"
              v-model="model.Nombre"
              aria-describedby="input-live-help"
              v-if="usuario"
              :state="nameState"
            ></base-input>
            
            <base-input :required="model.NombreComercio == null || model.NombreComercio.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Nombre del comercio"
              addon-left-icon="fa fa-fw fa-store"
              v-model="model.NombreComercio"
              v-if="comercio"
            ></base-input>

            <base-input :required="model.Apellido == null || model.Apellido.length == 0"
              class="mb-3"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Apellido"
              addon-left-icon="fa fa-fw fa-user"
              v-model="model.Apellido"
              v-if="usuario"
            ></base-input>
            
            
            <!-- <div class="form-group" style="text-align:center;margin-bottom: 0.5px;" > 
                <label class="text-center text-muted">
                  <small >¿Sos una persona<br> expuesta políticamente?</small>
                   <a slot="title" @click="openModalPersonExpose" class="btn btn-sm btn-icon-only text-blue" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     <i class="fas fa-question-circle"></i>
                   </a>
                </label>
            </div>
            <div class="form-group" style="text-align:center;margin-bottom:15px;">
            <input type="radio" style="margin-right: 7px;"   name="chexposed" id="no"  value="false" v-model="model.PoliticallyExposedPerson" >
            <label class="form-check-label" style="margin-right:20px;"  for="no">NO</label>
            <input type="radio" style="margin-right: 7px;"  name="chexposed" id="yes" value="true" v-model="model.PoliticallyExposedPerson">
            <label class="form-check-label " style="margin-right:20px;" for="yes">SI</label>
             </div> -->
            
            <!-- <base-input :required="model.Password == null || model.Password.length == 0"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Contraseña"
              type="password"
              addon-left-icon="fa fa-fw fa-unlock-alt"
              v-model="model.Password"
            ></base-input> -->

              <password-validator
                v-model="model.Password"
                @password-validated="updatePasswordValidity"
              ></password-validator>

            <base-input :required="model.PasswordRepetir == null || model.PasswordRepetir.length == 0"
              inputClasses="input-group-alternative input-text-indent"
              iconClasses="input-group-alternative"
              placeholder="Repetir contraseña"
              type="password"
              addon-left-icon="fa fa-fw fa-unlock-alt"
              v-model="model.PasswordRepetir"
            ></base-input>

            <label class="text-center text-muted">
              <small>Para mejorar tu experiencia y tu seguridad, si podés indicanos los siguientes datos</small>
            </label>
           
            <label class="text-center" style="width: 100%; color: #ff5855">
              <small>Ingresá tu número de teléfono</small>
            </label>
            <div class="row form-group" style="margin-bottom: 0;" >
              <div class="col-md-5" style="padding-right: 10px;">
                <base-input v-model="model.Prefijo" type="number" onlyNumbers validatorClasses="inputValidator" class="flexi" placeholder="Prefijo" :required="model.Prefijo == null || model.Prefijo == 0"></base-input>
              </div>
              <div class="col-md-7" >
                <base-input v-model="model.Numero" type="number" onlyNumbers validatorClasses="inputValidator" class="flexi" placeholder="Número" :required="model.Numero == null || model.Numero == 0"></base-input>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-12 text-muted">
                <label>
                  <small>Código de área + Nº. Ej.: 11 43239121.</small>
                </label>
              </div>
            </div>

            <label class="text-center" style="width: 100%; color: #ff5855">
              <small>¿Tenés un email?</small>
            </label>

            <base-input
              v-model="model.Mail"
              name="email"
              placeholder="Email"
              validatorClasses="inputValidator"
              inputClasses="input-text-indent"
              addon-left-icon="fa fa-fw fa-envelope"
              :required="model.Mail == null || model.Mail.length == 0"
            ></base-input>

            <base-input
              :required="model.MailRepetir == null || model.MailRepetir.length == 0 || model.Mail != model.MailRepetir"
              v-model="model.MailRepetir"
              v-validate="'email'"
              name="repetir mail"
              placeholder="Repetir email"
              validatorClasses="inputValidator"
              inputClasses="input-text-indent"
              addon-left-icon="fa fa-fw fa-envelope"
            ></base-input>
            <span class="validation-error">{{ errors.first('repetir mail') }}</span>

            <!-- <div class="row my-4">
              <div class="col-12">
                <base-checkbox class="" v-model="model.Acepta">
                  <span class="text-muted">
                    Acepto
                      <a
                        href="https://www.resimple.com.ar/legales/"
                        target="_blank"
                      >Acepto Términos y Condiciones</a>
                  </span>
                </base-checkbox>
              </div>
            </div> -->
            <div class="text-center">
              <base-button type="primary" class="my-4 bottomButton" @click="crearcuenta">Crear billetera</base-button>
            </div>
          </form>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6 text-left">
          <router-link to="/login" class="text-light">
            <small>Ingresá con tu cuenta</small>
          </router-link>
        </div>
      </div>
    </div>
    <contact-help-desk ref="contact-help-desk"/>
     <modal :show.sync="showModalPersonExpose">
            <div>
                <label class="modal-title">Una persona expuesta políticamente (PEP) es aquella persona que tiene (o tuvo) una función pública relevante, o que mantiene algún tipo de relación con personas en una función pública relevante."</label>
            </div>
        </modal>
  </div>  
</template>
<script>
import axios from 'axios';
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsCombo from "@/components/KitsCombo";
import ContactHelpDesk from '@/views/ContactHelpDesk';
import PasswordValidator from "@/components/Custom/PasswordValidator";
import firebase from "firebase";

export default {
  components: { 
    KitsCombo,
    "contact-help-desk": ContactHelpDesk,
    PasswordValidator
  },
  name: "register",
  data() {
    return {
      Required: false,
      comercio: true,
      usuario: false,
      timeElpased:false,
      timer:null,

      location:null,
      gettingLocation: false,
      errorStr:null,
      
      model: {
        DNI: null,
        CUIT: null,
        RazonSocial: "",
        Nombre: "",
        Apellido: "",
        NombreComercio: "",
        Password: "",
        PasswordRepetir: "",
        Prefijo: "",
        Numero: "",
        GenderID: "null",
        Acepta: false,
        OrderNumber: "",
        Latitude: 0,
        Longitude: 0,
        PoliticallyExposedPerson:false,
        deviceID: "",
        ipLogin: "",
        deviceModel: "",
        deviceModelID: "",
      },
      sexos: [],
      showModalPersonExpose:false,

      IsAddUserVisible:false,
    };
  },
  watch: {
    CUIT() {
       let context = this;
       if (context.model.CUIT.length > 10)
       {
          let req = { Cuit: context.model.CUIT };

          axiosHelpers.axiosPost("Account/GetAfipBusinessNameByCuit", req, context, function(data) {
          context.model.RazonSocial = data.ResponseVM.BusinessName;});
       }
       else if(context.model.CUIT.length == 0)
       {
          context.model.RazonSocial = "";
       }
    },    
  },
  created() {
    let context = this;
   
    if(!("geolocation" in navigator)) {
      return;
    }

    context.gettingLocation = true;
    // get position
    navigator.geolocation.getCurrentPosition(pos => {
      context.gettingLocation = false;
      context.location = pos;
    }, err => {
      context.gettingLocation = false;
      context.errorStr = err.message;
    })
  },
  beforeMount: function() {
    let context = this;
    this.Required = false;
    axiosHelpers.axiosGet("Gender/GetAll", {}, this, function(data) {
      context.sexos = data.ResponseVM.Genders;
    });

    axiosHelpers.axiosGet("Login/GetInfoByRegister", {}, this, function(data) {
      context.IsAddUserVisible = data.ResponseVM.IsAddUserVisible;
    });
  },
  computed: {
    nameState() {
        return this.model.Nombre > 2 ? true : false
      },
    CUIT() {
      let context = this;
      return context.model.CUIT;
    }
  },
  methods: {
    updatePasswordValidity(isValid) {
      let context = this;
      context.model.passwordIsValid = isValid;
    },
    soyusuario() {
      this.usuario = true;
      this.comercio = false;
    },
    timerRefresh(){
      let context = this;
              context.timeElpased=false;
      if(context.timer!=null)
      clearTimeout(context.timer);
      context.timer = setTimeout(function(){
        context.timeElpased=true;
        context.model.GenderID="null";
      },500);
    }
    ,
    soycomercio() {
      this.usuario = false;
      this.comercio = true;
    },
    async getIp(){
      let context = this;
       try {
          const response = await axios.get('https://api64.ipify.org?format=json');
          context.model.ipLogin = response.data.ip;
        } catch (error) {
          console.log("Error obtener IP: " + error);
        }
    },
   crearcuenta() {
      let context = this;

      // const messaging = firebase.messaging();
      // context.model.deviceID = await messaging.getToken();

      this.$validator.validate().then(valid => {
        if (context.usuario) {
          if (
            context.model.Nombre == "" ||
            context.model.Apellido == "" ||
            context.model.DNI == "" ||
            context.model.Password == "" ||
            context.model.PasswordRepetir == "" ||
            context.model.Prefijo == "" ||
            context.model.Numero == "" ||
            context.model.OrderNumber == "" ||
            context.model.Mail == "" ||
            context.model.MailRepetir == ""
          ) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Complete todos los campos requeridos",
              context
            );
            this.Required = true;
            return;
          }
          
          if (context.model.GenderID == null || context.model.GenderID == 0 || isNaN(context.model.GenderID)) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Debe seleccionar un sexo",
              context
            );
            return;
          }

          if (context.model.PoliticallyExposedPerson == null ) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Debe seleccionar si la persona es o no políticamente expuesta",
              context
            );
            return;
          }

        }

        if (context.comercio) {
          if (
            context.model.RazonSocial == "" ||
            context.model.NombreComercio == "" ||
            context.model.CUIT == "" ||
            context.model.Password == "" ||
            context.model.PasswordRepetir == "" ||
            context.model.Prefijo == "" ||
            context.model.Numero == "" ||
            context.model.Mail == "" ||
            context.model.MailRepetir == ""
          ) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Complete todos los campos requeridos",
              context
            );
            this.Required = true;
            return;
          }

          if (!/^([0-9])*$/.test(context.model.CUIT.trim())) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "El CUIT debe tener solo números, sin guiones",
              context
            );
            return;
          }
        }

        if (context.model.Password != context.model.PasswordRepetir) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Las contraseñas deben ser iguales",
            context
          );
          return;
        }

        if ((context.model.Mail != null && context.model.Mail.length > 0) &&
            context.model.Mail != context.model.MailRepetir) 
        {
          notificationHelpers.showWarning(
            "Advertencia!",
            "No coincide el mail",
            context
          );
          return;
        }

        if(context.model.Prefijo.length > 5){
           notificationHelpers.showWarning(
            "Advertencia!",
            "El préfijo no debe superar los 5 dígitos",
            context
          );
          return;
        }

        if((context.model.Prefijo.length + context.model.Numero.length) != 10){
           notificationHelpers.showWarning(
            "Advertencia!",
            "El préfijo y número deben sumar 10 dígitos",
            context
          );
          return;
        }

        // if (!context.model.Acepta) {
        //   notificationHelpers.showWarning(
        //     "Advertencia!",
        //     "Debe aceptar los terminos y condiciones",
        //     context
        //   );
        //   return;
        // }

        if (
          context.model.Password == context.model.Nombre ||
          context.model.Password == context.model.NombreComercio ||
          context.model.Password == context.model.Apellido ||
          context.model.Password == context.model.RazonSocial ||
          context.model.Password == context.model.DNI ||
          context.model.Password == context.model.CUIT
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La contraseña no puede ser ningún dato personal",
            context
          );
          return;
        }

        if (!/\d/.test(context.model.Password)) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La contraseña debe tener al menos un número",
            context
          );
          return;
        }

        var telPrefixRegEx = /(^0)/;
        if(telPrefixRegEx.test(context.model.Prefijo))
        {
          notificationHelpers.showWarning(
            "Advertencia!",
            "El código de area no debe empezar con 0",
            context
          );
          return;
        }

        // Si arranca con 15 aviso que no se debe ingresar asi
        var telRegEx = /(^15)/;
        if(telRegEx.test(context.model.Numero))
        {
          notificationHelpers.showWarning(
            "Advertencia!",
            "El número de teléfono no debe empezar con 15",
            context
          );
          return;
        }
        
        var lat = 0;
        var long = 0;

        if(context.location != null)
        {
            lat = context.location.coords.latitude;
            long = context.location.coords.longitude;
        }
        
        const userAgent = navigator.userAgent;
        context.model.deviceModel = context.model.ipLogin + '_' + userAgent;

        // Convertir la cadena a Base64
        context.model.deviceModelID = btoa(this.model.deviceModel);

        let req = {
          Password: context.model.Password,
          Mail: context.model.Mail,
          GenderID: context.model.GenderID,
          Prefix: context.model.Prefijo,
          Telephone: context.model.Numero,
          RegisterVersion: "Web",
          Name: context.model.Nombre,
          SurnameBusinessname: context.model.Apellido,
          NumberID: context.model.DNI,
          User: context.usuario,
          OrderNumber: context.model.OrderNumber,
          Longitude: long,
          Latitude: lat,
          PoliticallyExposedPerson:context.model.PoliticallyExposedPerson,
          DeviceID: context.model.deviceID,
          IPLogin: context.model.ipLogin,
          DeviceModel: context.model.deviceModel,
          DeviceModelID: context.model.deviceModelID,
          TermsAndConditionsAccepted: context.model.Acepta
        };

        if (context.comercio) {
          (req.Name = context.model.NombreComercio),
            (req.SurnameBusinessname = context.model.RazonSocial),
            (req.NumberID = context.model.CUIT.trim());
        }

        axiosHelpers.axiosPostWithoutAlerts("Account/Register", req, this, function(data) {
          if (data.ResponseVM.Resultado) {
            notificationHelpers.showSuccess(
              "Listo!",
              "Ya creamos tu billetera. Comenzá a disfrutar de Resimple. Te enviamos un mail a " + context.model.Mail + " para verificar tu correo.",
              context
            );
            context.$router.push("login");
          } else if (data.ResponseVM.HelpDeskInformation != null && data.ResponseVM.InvalidIdentityValidation) {
            var helpDeskInformation = data.ResponseVM.HelpDeskInformation;
            helpDeskInformation.Message = data.Alerts[0].Message;
            helpDeskInformation.Show = true;
            context.$refs["contact-help-desk"].setHelpDeskInformation(helpDeskInformation);
          } else {
            context.Required = true;
            notificationHelpers.showError(
              "Alerta!",
              data.Alerts[0].Message,
              context
            );
          }
        });
      });
    },
    openModalPersonExpose(){
      let context = this;
      context.showModalPersonExpose=true;
    },
    getRenaperData(){
      let context = this;

      var dni = "";
      if(context.model.DNI != null){
        dni = context.model.DNI.toString();
      }

      if(dni.length < 7|| dni.length > 8) {
        context.initializeNombreApellido();
        return;
      }

      if(context.model.OrderNumber.length != 11) {
        context.initializeNombreApellido();
        return;
      }

      if(context.model.GenderID == "null" || isNaN(context.model.GenderID)){
        context.initializeNombreApellido();
        return;
      }

      axiosHelpers.axiosGet(
        "Account/GetRepanerDataBeforeAccountCreation",
        {
          Number: dni,
          OrderNumber: context.model.OrderNumber,
          GenderID: context.model.GenderID
        },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            context.model.Nombre = data.ResponseVM.Data.Names;
            context.model.Apellido = data.ResponseVM.Data.LastNames;
          }else{
            context.initializeNombreApellido();
          }
        }
      );
    },
    initializeNombreApellido(){
      let context = this;
      context.model.Nombre = "";
      context.model.Apellido = "";
    }
  },
  beforeMount(){
    this.getIp();
  }
};
</script>
<style>

::placeholder {
  color: red;
}

.flexi {
  display:flex;
  flex-flow:row;  
}

/* .form-group>span */
.inputValidator
{
  margin-left: 3px;
}

.bottomButton
{
  width:  100%;
}

</style>
